import type { ExercisePosition, ExerciseRegion, ExerciseTag } from '@erectus/shared';

/** Reader-facing names for exercise tags; the tag ids never reach the screen. */
export const TAG_LABEL: Record<ExerciseTag, string> = {
  fhp: 'Neck',
  'thoracic-ext': 'Upper back',
  scap: 'Shoulder blades',
  core: 'Core',
  lbp: 'Lower back',
  asymmetry: 'Left–right',
  general: 'Breaks',
};

/** The PT list's groups (2026-10-16), as the library filters them. */
export const REGION_LABEL: Record<ExerciseRegion, string> = {
  cervical: 'Neck',
  thoracic: 'Upper back',
  posture: 'Posture',
  stretch: 'Stretches',
};

export const POSITION_LABEL: Record<ExercisePosition, string> = {
  seated: 'seated',
  standing: 'standing',
  supine: 'lying on your back',
  prone: 'lying face down',
  quadruped: 'on hands and knees',
  'side-lying': 'lying on your side',
};
